import { _ as e } from "./tslib.es6-7f1b1220.js";
import { c as i, u as n, h as t, n as r } from "./lit-element-161a1699.js";
import { p as a, a as o, s, c as l } from "./decorators-7e9cd43b.js";
import { c as d } from "./class-map-31af68b2.js";
import { h as c } from "./host.styles-cf05db22.js";
import { e as h } from "./event.decorator-98549cbc.js";
import "./types-814d68fb.js";
import { commaListConverter as u, clamp as b, numberUndefinedConverter as v } from "./component.utils.esm.min.js";
import { getCursorPosition as g } from "./dom.utils.esm.min.js";
import { D as m } from "./delegate-focus.mixin-95600d1f.js";
import { s as _ } from "./style-map-a37d7105.js";
import { d as k } from "./decimal-fc7b1704.js";
import { SliderBaseClass as p } from "./slider-base.class.esm.min.js";
import { countDecimals as z } from "./format.utils.esm.min.js";
function f(e, i, n, t) {
  return "any" === n ? t : [...new Array(new k.Decimal(i).minus(e).dividedBy(n).plus(1).toNumber())].map((i, t) => new k.Decimal(t).mul(n).plus(e).toNumber()).reduce((e, i) => k.Decimal.abs(i - t).lessThan(k.Decimal.abs(e - t)) ? i : e, 1 / 0);
}
function y(e, i, n) {
  return "any" === n || k.Decimal.mod(new k.Decimal(i).minus(e), new k.Decimal(n)).equals(0);
}
function A(e, i, n) {
  return k.Decimal.mod(new k.Decimal(i).minus(e), new k.Decimal(n)).equals(0);
}
function K(e, [i, n], t) {
  return A(e, i, t) && A(e, n, t);
}
const L = {
  fromAttribute: e => u.fromAttribute(e).map(e => Number(e)),
  toAttribute: e => u.toAttribute((null != e ? e : []).map(e => String(e)))
};
var w;
const E = i`${n(".delayed-margin-transition {\n  transition: margin-left 1.6s;\n  transition-timing-function: linear;\n}\n\n:host {\n  display: flex;\n  flex-direction: column;\n  ---zui-slider-height: 100%;\n  ---zui-slider-knob-semicircle-height: calc(var(--zui-gu) * 2);\n  ---zui-slider-knob-semicircle-width: calc(var(--zui-gu) * 1.625);\n  ---zui-slider-knob-semicircle-border: 0 calc(var(--zui-gu) * 1.125) calc(var(--zui-gu) * 1.125) 0;\n  ---zui-slider-knob-semicircle-inverted-border: calc(var(--zui-gu) * 1.125) 0 0 calc(var(--zui-gu) * 1.125);\n  ---zui-slider-knob-semicircle-height-readonly: calc(var(--zui-gu) * 1);\n  ---zui-slider-knob-semicircle-width-readonly: calc(var(--zui-gu) * 0.875);\n  ---zui-slider-knob-semicircle-height-hover: calc(var(--zui-gu) * 2.25);\n  ---zui-slider-knob-semicircle-width-hover: calc(var(--zui-gu) * 1.875);\n  ---zui-slider-knob-diameter: calc(var(--zui-gu) * 2);\n  ---zui-slider-knob-border-width: calc(var(--zui-gu) * 0.25);\n  ---zui-slider-knob-diameter-readonly: calc(var(--zui-gu) * 1);\n  ---zui-slider-knob-diameter-hover: calc(var(--zui-gu) * 2.25);\n  ---zui-slider-knob-margin-readonly: calc(var(--zui-gu) * 0.625);\n  ---zui-slider-knob-border-width-readonly: calc(var(--zui-gu) * 0.5);\n  ---zui-slider-range-line-height: calc(var(--zui-gu) * 0.25);\n  ---zui-slider-padding-in-px: calc(var(--zui-slider-padding) * 1px);\n  ---zui-slider-min-padding-in-px: calc(var(--zui-slider-min-padding) * 1px);\n  ---zui-slider-max-padding-in-px: calc(var(--zui-slider-max-padding) * 1px);\n  height: var(---zui-slider-height);\n  width: calc(var(--zui-slider-width, 100%) - calc(var(--zui-gu) * 2));\n  margin: 0 auto;\n  min-height: calc(var(--zui-gu) * 2);\n}\n\n:host(:focus),\n*:focus {\n  outline: none;\n}\n\n:host(:not([dual-knobs])) .knob-container > .knob {\n  transform: translateX(-50%);\n}\n:host(:not([dual-knobs])) .range-line.active {\n  left: var(---zui-slider-active-line-start, calc(var(---zui-slider-padding-in-px, calc(var(--zui-gu) * 1)) * -1));\n  right: calc(100% - var(---zui-slider-knob-a-shift, auto));\n  margin: 0 var(---zui-slider-active-line-margin-right, 0) 0 var(---zui-slider-active-line-margin-left, 0);\n}\n:host(:not([dual-knobs])) .range-line.active.right-to-left {\n  left: var(---zui-slider-knob-a-shift, auto);\n  right: calc( 100% - var( ---zui-slider-active-line-start, calc(100% + calc(var(---zui-slider-padding-in-px, calc(var(--zui-gu) * 1)) * 1)) ) );\n}\n\n:host([disabled]) {\n  pointer-events: none;\n}\n:host([disabled]) .knob {\n  background: var(--zui-color-slider-handle-fill-disabled);\n  border-color: var(--zui-color-slider-handle-border-disabled);\n  pointer-events: none;\n}\n:host([disabled]) .knob.ghost {\n  display: none;\n}\n:host([disabled]) .range-line {\n  background: var(--zui-color-slider-track-disabled);\n  opacity: 0.5;\n}\n:host([disabled]) .range-line.active {\n  opacity: 1;\n  background: var(--zui-color-slider-active-line-disabled);\n}\n\n:host([readonly]) {\n  /* in readonly the knob should be smaller */\n  ---zui-slider-knob-diameter: var(---zui-slider-knob-diameter-readonly);\n  pointer-events: none;\n}\n:host([readonly]) .range-line {\n  background: var(--zui-color-slider-track-readonly-enabled);\n}\n:host([readonly]) .range-line.active {\n  background: var(--zui-color-slider-active-line-readonly-enabled);\n}\n:host([readonly]) .knob {\n  border: none;\n  background: var(--zui-color-slider-handle-fill-readonly-enabled);\n}\n:host([readonly]) .knob.semicircle {\n  ---zui-slider-knob-semicircle-height: var(---zui-slider-knob-semicircle-height-readonly);\n  ---zui-slider-knob-semicircle-width: var(---zui-slider-knob-semicircle-width-readonly);\n}\n:host([readonly]) .knob.ghost {\n  display: none;\n}\n\n:host([readonly][disabled]) {\n  pointer-events: none;\n}\n:host([readonly][disabled]) .range-line {\n  background: var(--zui-color-slider-track-disabled);\n  opacity: 0.5;\n}\n:host([readonly][disabled]) .range-line.active {\n  opacity: 1;\n  background: var(--zui-color-slider-active-line-disabled);\n}\n:host([readonly][disabled]) .knob {\n  background: var(--zui-color-slider-handle-fill-disabled-readonly);\n}\n\n:host([active-line-disabled]) .range-line.active {\n  display: none;\n}\n\n.slider {\n  position: relative;\n  flex: 1;\n  width: 100%;\n  cursor: pointer;\n  touch-action: pan-x;\n}\n.slider:focus {\n  outline: none;\n}\n\n.range-line {\n  width: var(--zui-slider-width, calc(100% + calc(var(--zui-gu) * 2)));\n  height: var(---zui-slider-range-line-height);\n  position: absolute;\n  bottom: 0;\n  left: auto;\n  right: calc(calc(var(--zui-gu) * 1) * -1);\n  top: calc((var(---zui-slider-height) - var(---zui-slider-range-line-height)) / 2);\n  background-color: var(--zui-color-slider-track-readonly-enabled);\n}\n.range-line.active {\n  width: auto;\n  background-color: var(--zui-color-slider-active-line-readonly-enabled);\n  left: var(---zui-slider-knob-a-shift, auto);\n  right: calc(100% - var(---zui-slider-knob-b-shift));\n  bottom: 0;\n}\n\n.knob-container {\n  height: var(---zui-slider-height);\n  position: relative;\n  margin: 0 calc(var(---zui-slider-padding-in-px) - var(--zui-gu)) 0 calc(var(---zui-slider-padding-in-px) - var(--zui-gu));\n  user-select: none;\n}\n\n.knob {\n  cursor: pointer;\n  box-sizing: border-box;\n  height: var(---zui-slider-knob-diameter);\n  width: var(---zui-slider-knob-diameter);\n  background: var(--zui-color-slider-handle-fill-enabled);\n  border: solid var(---zui-slider-knob-border-width);\n  border-radius: var(---zui-slider-knob-diameter);\n  border-color: var(--zui-color-slider-handle-border-enabled);\n  position: absolute;\n  bottom: calc((var(---zui-slider-height) - var(---zui-slider-knob-diameter)) / 2);\n  left: auto;\n  right: auto;\n  top: calc((var(---zui-slider-height) - var(---zui-slider-knob-diameter)) / 2);\n  margin-left: var(---zui-slider-shift, var(---zui-slider-knob-a-shift));\n}\n.knob.dragging, .knob:hover, .knob:focus-visible {\n  background: var(--zui-color-slider-handle-fill-hover);\n  border-color: var(--zui-color-slider-handle-border-hover);\n}\n.knob.b {\n  margin-left: var(---zui-slider-shift, var(---zui-slider-knob-b-shift));\n}\n.knob.b.semicircle {\n  ---translateXKnobB: calc(var(---zui-slider-knob-semicircle-width) * -0.09);\n  height: var(---zui-slider-knob-semicircle-height);\n  width: var(---zui-slider-knob-semicircle-width);\n  border-radius: var(---zui-slider-knob-semicircle-border);\n  transform: translateX(var(---translateXKnobB));\n}\n.knob.b.semicircle.dragging, .knob.b.semicircle:hover, .knob.b.semicircle:focus-visible {\n  ---zui-slider-knob-semicircle-inverted-border: calc(var(--zui-gu) * 1.125) 0 0 calc(var(--zui-gu) * 1.125);\n  transform: translate(var(---translateXKnobB), -1px);\n}\n.knob.ghost {\n  background: var(--zui-color-slider-handle-fill-ghost);\n  border-color: var(--zui-color-slider-handle-border-ghost);\n  pointer-events: none;\n  margin-left: var(---zui-slider-knob-ghost-shift);\n}\n.knob.semicircle {\n  ---translateXKnobB: calc(var(---zui-slider-knob-semicircle-width) * -0.09);\n  height: var(---zui-slider-knob-semicircle-height);\n  width: var(---zui-slider-knob-semicircle-width);\n  border-radius: var(---zui-slider-knob-semicircle-border);\n  transform: translateX(var(---translateXKnobB));\n  ---translateXKnobA: calc(var(---zui-slider-knob-semicircle-width) * -0.91);\n  border-radius: var(---zui-slider-knob-semicircle-inverted-border);\n  transform: translateX(var(---translateXKnobA));\n}\n.knob.semicircle.dragging, .knob.semicircle:hover, .knob.semicircle:focus-visible {\n  ---zui-slider-knob-semicircle-border: 0 calc(var(--zui-gu) * 1.125) calc(var(--zui-gu) * 1.125) 0;\n  ---zui-slider-knob-semicircle-height: var(---zui-slider-knob-semicircle-height-hover);\n  ---zui-slider-knob-semicircle-width: var(---zui-slider-knob-semicircle-width-hover);\n  background: var(--zui-color-slider-handle-fill-hover);\n  border-color: var(--zui-color-slider-handle-border-hover);\n  transform: translate(var(---translateXKnobA), -1px);\n}")}`;
let S = w = class extends m(p) {
  constructor() {
    super(...arguments), this.tabindex = 0, this.activeLineDisabled = !1, this.dualKnobs = !1, this.ghostHandle = void 0, this.readonly = !1, this.disabled = !1, this.value = this.min, this._knobAisDragged = !1, this._knobBisDragged = !1, this._moveKnobBound = this._moveKnob.bind(this), this._endMoveKnobBound = this._endMoveKnob.bind(this), this._advanceValueByStepInDirection = e => {
      let i = "any" === this._derivedStep ? w.DEFAULT_KEYBOARD_STEP_SIZE : Number(this._derivedStep);
      "left" === e && (i *= -1), this.dualKnobs ? "a" === this._activeKnob ? this._clampAndSetRangeValue([this._knobAValue + i, this._knobBValue]) : "b" === this._activeKnob && this._clampAndSetRangeValue([this._knobAValue, this._knobBValue + i]) : this._singleValue = b(this.min, this._singleValue + i, this.max);
    };
  }
  static get styles() {
    return [c, E];
  }
  emitInputEvent() {
    this.dispatchEvent(new Event("input", {
      bubbles: !0,
      composed: !0
    }));
  }
  emitChangeEvent() {
    this.dispatchEvent(new Event("change", {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }));
  }
  get _derivedStep() {
    return "any" === this.step ? this.step : isNaN(Number(this.step)) || Number(this.step) <= 0 ? 1 : this.step;
  }
  get _derivedGhostHandleValue() {
    return this.ghostHandle < this.min || this.ghostHandle > this.max ? void 0 : this.ghostHandle;
  }
  get _showGhostHandle() {
    return void 0 !== this._derivedGhostHandleValue;
  }
  get _isOddStep() {
    return !y(this.min, this.max, this._derivedStep);
  }
  get _decimalPlaces() {
    return "any" !== this._derivedStep ? z(this._derivedStep) : w.DEFAULT_VALUE_DECIMAL_PLACES;
  }
  get _knobAPositionX() {
    return this._knobA.getBoundingClientRect().x;
  }
  get _knobBPositionX() {
    return this.dualKnobs ? this._knobB.getBoundingClientRect().x : this._knobAPositionX;
  }
  get _range() {
    return this.max - this.min;
  }
  get _knobContainerLeft() {
    return this._knobContainerRef.getBoundingClientRect().left;
  }
  get _knobContainerWidth() {
    return this._knobContainerRef.getBoundingClientRect().width;
  }
  get _derivedActiveLineStart() {
    switch (this.activeLineStart) {
      case "min":
        return 0;
      case "max":
        return 100;
      default:
        return (b(this.min, this.activeLineStart, this.max) - this.min) / this._range * 100;
    }
  }
  get _activeLineMarginLeft() {
    switch (this.activeLineStart) {
      case "min":
        return -w.ONE_MILLION;
      case "max":
        return 0;
      default:
        return this.activeLineStart <= this.min ? -w.ONE_MILLION : 0;
    }
  }
  get _activeLineMarginRight() {
    switch (this.activeLineStart) {
      case "min":
        return 0;
      case "max":
        return -w.ONE_MILLION;
      default:
        return this.activeLineStart >= this.max ? -w.ONE_MILLION : 0;
    }
  }
  get _drawActiveLineRightToLeft() {
    switch (this.activeLineStart) {
      case "min":
        return !1;
      case "max":
        return !0;
      default:
        return this._singleValue < this.activeLineStart;
    }
  }
  get _knobAValue() {
    return this.dualKnobs ? this._rangeValue[0] : this._singleValue;
  }
  get _knobAShift() {
    return this._getKnobShiftByValue(this._knobAValue);
  }
  get _knobBShift() {
    return this._getKnobShiftByValue(this._knobBValue);
  }
  get _knobGhostShift() {
    return void 0 !== this._derivedGhostHandleValue ? this._getKnobShiftByValue(this._derivedGhostHandleValue) : void 0;
  }
  get _knobBValue() {
    return this._rangeValue[1];
  }
  get _singleValue() {
    return this.value;
  }
  set _singleValue(e) {
    this.value = e;
  }
  get _rangeValue() {
    return this.value;
  }
  set _rangeValue(e) {
    this.value = e;
  }
  _getKnobShiftByValue(e) {
    return 100 * (b(this.min, e, this.max) - this.min) / this._range;
  }
  _emitEvents() {
    this.emitChangeEvent(), this.emitInputEvent();
  }
  _getCursorPositionX(e) {
    const {
      clientX: i
    } = g(e);
    return i;
  }
  _checkHoveredKnobAndStartMoving(e) {
    switch (e.target.id) {
      case "knob-a":
        this._hoveredKnob = "a", this._activeKnob = "a";
        break;
      case "knob-b":
        this._hoveredKnob = "b", this._activeKnob = "b";
        break;
      default:
        this._hoveredKnob = null, this._activeKnob = null;
    }
    this._startMoveKnob(e);
  }
  _startMoveKnob(e) {
    window.addEventListener("mousemove", this._moveKnobBound, !1), window.addEventListener("mouseup", this._endMoveKnobBound, !1), window.addEventListener("touchmove", this._moveKnobBound, !1), window.addEventListener("touchend", this._endMoveKnobBound, !1);
    const i = Math.abs(this._getCursorPositionX(e) - this._knobAPositionX),
      n = Math.abs(this._getCursorPositionX(e) - this._knobBPositionX),
      t = Math.abs(i + w.SEMICIRCLE_KNOB_A_DEFAULT_TRANSLATION - n + w.SEMICIRCLE_KNOB_B_DEFAULT_TRANSLATION);
    null === this._hoveredKnob && (this._activeKnob = i + w.SEMICIRCLE_KNOB_A_DEFAULT_TRANSLATION <= n + w.SEMICIRCLE_KNOB_B_DEFAULT_TRANSLATION ? "a" : "b"), this.dualKnobs && "a" !== this._activeKnob ? "b" === this._activeKnob && (this._knobBisDragged = !0) : this._knobAisDragged = !0, ("a" === this._activeKnob && t > Math.abs(w.SEMICIRCLE_KNOB_A_DEFAULT_TRANSLATION) || "b" === this._activeKnob) && this._moveKnob(e);
  }
  _moveKnob(e) {
    const i = 100 * b(0, (this._getCursorPositionX(e) - this._knobContainerLeft) / this._knobContainerWidth, 1),
      n = this._knobPositionToValue(i);
    if (this.dualKnobs) {
      let e = "a" === this._activeKnob ? n : this._rangeValue[0],
        i = "b" === this._activeKnob ? n : this._rangeValue[1];
      this._isOddStep || (e = f(this.min, this.max, this._derivedStep, e), i = f(this.min, this.max, this._derivedStep, i)), this._clampAndSetRangeValue([e, i]);
    } else this._singleValue = this._isOddStep ? n : f(this.min, this.max, this._derivedStep, n);
    this._emitEvents();
  }
  _endMoveKnob() {
    window.removeEventListener("mousemove", this._moveKnobBound, !1), window.removeEventListener("mouseup", this._endMoveKnobBound, !1), window.removeEventListener("touchmove", this._moveKnobBound, !1), window.removeEventListener("touchend", this._endMoveKnobBound, !1), this._knobAisDragged = !1, this.dualKnobs && (this._knobBisDragged = !1);
  }
  _knobPositionToValue(e) {
    return parseFloat((this.min + this._range * (e / 100)).toFixed(this._decimalPlaces));
  }
  _clampAndSetRangeValue([e, i]) {
    this._rangeValue = [b(this.min, e, this._knobBValue), b(this._knobAValue, i, this.max)];
  }
  _handleKeyDown(e) {
    if (!this.readonly && !this.disabled) {
      switch (e.target.id) {
        case "knob-a":
          this._activeKnob = "a";
          break;
        case "knob-b":
          this._activeKnob = "b";
      }
      switch (e.key) {
        case "ArrowLeft":
        case "ArrowDown":
          this._advanceValueByStepInDirection("left"), this._emitEvents();
          break;
        case "ArrowRight":
        case "ArrowUp":
          this._advanceValueByStepInDirection("right"), this._emitEvents();
      }
    }
  }
  render() {
    return t`<div zuiCaptureFocus class="slider" @touchstart="${this._checkHoveredKnobAndStartMoving}" @mousedown="${this._checkHoveredKnobAndStartMoving}" @mouseup="${this._endMoveKnob}" @touchend="${this._endMoveKnob}" style="${_({
      "---zui-slider-knob-a-shift": `${this._knobAShift}%`,
      "---zui-slider-knob-b-shift": `${this._knobBShift}%`
    })}"><div class="range-line"></div><div class="knob-container"><div class="range-line active ${d({
      "right-to-left": this._drawActiveLineRightToLeft
    })}" style="${_({
      "---zui-slider-active-line-start": `${this._derivedActiveLineStart}%`,
      "---zui-slider-active-line-margin-left": `${this._activeLineMarginLeft}px`,
      "---zui-slider-active-line-margin-right": `${this._activeLineMarginRight}px`
    })}"></div>${this._showGhostHandle ? t`<div tabindex="0" id="knob-ghost" class="knob ghost" style="${_({
      "---zui-slider-knob-ghost-shift": `${this._knobGhostShift}%`
    })}"></div>` : r}<div tabindex="0" id="knob-a" class="knob a ${d({
      semicircle: this.dualKnobs,
      dragging: this._knobAisDragged
    })}" @keydown="${this._handleKeyDown}"></div>${this.dualKnobs ? t`<div tabindex="0" id="knob-b" class="knob b semicircle ${d({
      dragging: this._knobBisDragged
    })}" @keydown="${this._handleKeyDown}"></div>` : r}</div></div>`;
  }
};
S.DEFAULT_KEYBOARD_STEP_SIZE = 1, S.DEFAULT_VALUE_DECIMAL_PLACES = 2, S.ONE_MILLION = Math.pow(10, 6), S.SEMICIRCLE_KNOB_A_DEFAULT_TRANSLATION = -11.83, S.SEMICIRCLE_KNOB_B_DEFAULT_TRANSLATION = -1.17, e([a({
  reflect: !0,
  type: Number
})], S.prototype, "tabindex", void 0), e([a({
  reflect: !0,
  type: Boolean,
  attribute: "active-line-disabled"
})], S.prototype, "activeLineDisabled", void 0), e([a({
  reflect: !0,
  type: Boolean,
  attribute: "dual-knobs"
})], S.prototype, "dualKnobs", void 0), e([a({
  reflect: !0,
  attribute: "ghost-handle",
  converter: v
})], S.prototype, "ghostHandle", void 0), e([a({
  reflect: !0,
  type: Boolean
})], S.prototype, "readonly", void 0), e([a({
  reflect: !0,
  type: Boolean
})], S.prototype, "disabled", void 0), e([a({
  reflect: !0
})], S.prototype, "value", void 0), e([h()], S.prototype, "emitInputEvent", null), e([h()], S.prototype, "emitChangeEvent", null), e([o(".slider")], S.prototype, "_sliderRef", void 0), e([o(".knob-container")], S.prototype, "_knobContainerRef", void 0), e([o(".knob.a")], S.prototype, "_knobA", void 0), e([o(".knob.b")], S.prototype, "_knobB", void 0), e([s()], S.prototype, "_knobAisDragged", void 0), e([s()], S.prototype, "_knobBisDragged", void 0), S = w = e([l("zui-slider-custom")], S);
export { S, A as a, K as b, y as i, L as s };
